import {
    Verify,
    Register,
    Homepage,
    Login
} from './Pages';

import Dashboard from './Dashboard';
import {UserSettings} from './User';

import {
  PatientExport
} from './Patient';

import {
  StatisticsPID,
  StatisticsCountry,
  StatisticsGender,
  StatisticsCoverageMap
} from './Statistics';

export {
  Verify,
  Register,
  Homepage,
  Login,
  Dashboard,
  UserSettings,
  PatientExport,
  StatisticsPID,
  StatisticsCountry,
  StatisticsGender,
  StatisticsCoverageMap
};


// WEBPACK FOOTER //
// ./src/views/index.js